/*
	http://ccoenraets.github.io/es6-tutorial/classes/
	http://stackoverflow.com/questions/37912857/exporting-a-class-with-webpack-and-babel-not-working
 */

// require("../css/style.scss");
import Deslider from './deslider';
module.exports = Deslider;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/main.js
 **/